// ArticalWrap.js

import {
  defineComponent,
  toRefs,
  ref,
  computed,
  inject,
} from "/Scripts/vue.esm-browser.js";
import { getTextWithoutSign } from "/Scripts/tools.js";
import FilterPanel from "/Component/Shop/filter/FilterPanel.js";
import ProductCard from "/Component/Shop/product/ProductCard.js";
import LocationArea from "/Component/Shop/product/LocationArea.js";
import FilterTag from "/Component/Shop/filter/FilterTag.js";
const html = String.raw;

export default defineComponent({
  name: "ArticalWrap",
  props: {
    filters: {
      type: Object,
      required: true,
    },
    groupData: {
      type: Array,
      required: true,
    },
    resetFilters: {
      type: Function,
      required: true,
    },
    filteredDataByGroup: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["groupShowType"],
  emits: ["update:filters", "reset-filters"],
  components: {
    FilterPanel,
    ProductCard,
    LocationArea,
    FilterTag,
  },
  setup(props, { emit }) {
    // Reactive state for filter panel visibility
    const isFilterOpen = ref(true);
    const { groupData, resetFilters, filteredDataByGroup } = toRefs(props);
    const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
    const filterCount = inject("filterCount");
    const showRegionTitle = computed(() => {
      return filteredDataByGroup.value.length > 1;
    });

    const filtersProxy = computed({
      get: () => props.filters,
      set: (newFilters) => {
        emit("update:filters", newFilters);
      },
    });

    // Handle filter toggle
    const toggleFilter = () => {
      isFilterOpen.value = !isFilterOpen.value;
    };
    return {
      filtersProxy,
      data: groupData,
      resetFilters,
      filteredDataByGroup,
      showRegionTitle,
      isFilterOpen,
      toggleFilter,
      mobileFilterPopup,
      filterCount,
      loading: toRefs(props).loading,
    };
  },

  template: html`
    <!-- Template remains the same -->
    <div
      class="artical_wrap"
      :class="{ 'status-img': groupShowType === 'vertical' }"
    >
      <div class="leftsidebar-product_wrap">
        <div class="leftsidebar-product_grid" :class="{'active':!isFilterOpen}">
          <!-- 篩選  -->
          <filter-panel
            v-model:filters="filtersProxy"
            :group-data="data"
            @reset-filters="resetFilters"
            :is-filter-open="isFilterOpen"
            @toggle-filter="toggleFilter"
          ></filter-panel>

          <div class="product_wrap">
            <div class="product_container">
              <filter-tag
                v-model:filters="filtersProxy"
                @reset-filters="resetFilters"
              ></filter-tag>
              <!-- 這邊放入搜尋結果上半部 -->
              <!-- 依地點為區塊 -->
              <div
                v-for="area in filteredDataByGroup"
                :key="area.areaName"
                :data-area-name="getTextWithoutSign(area.areaName)"
              >
                <div v-if="showRegionTitle" class="region_title">
                  {{ area.areaName }}
                </div>
                <location-area
                  v-for="item in area.subAreas"
                  :key="item.subArea"
                  :item="item"
                  :isFilterOpen="isFilterOpen"
                  :loading="loading"
                ></location-area>
              </div>
            </div>
            <div v-if="filterCount>0" class="noProduct_text-bottom">
              找不到行程？
              <button
                class=" filter_dialog_btn"
                @click="mobileFilterPopup=true"
              >
                重新篩選
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  methods: {
    getTextWithoutSign(text) {
      return getTextWithoutSign(text);
    },
  },
});
